//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import Api from "../../utils/config";
  import {mapState} from 'vuex'
  export default {
    data () {
      return {}
    },
    props: {
      orderId: Number,
      tableData: Array,
      orderDate: Number,
      status: Number,
      amount: Number,
      orderNo: String
    },
    computed:{
      ...mapState(['specName','specNameEn']),
      specNames(){
         return  this.$i18n.locale  === 'en' ? this.specNameEn : this.specName;
      },
      totalQty(){
        let qty = 0
        this.tableData.map(item => {
          qty += item.qty;
        })
        return qty;
      }
    },
    methods: {
      queryOrderDetail (orderId) {
        this.$router.push({path: '/orderDetailMb/' + orderId, query: {cid: this.$route.query.cid}})
      },
      payMoney (orderId) {
        window.location = Api.paymentMb + this.orderId;
      },
      keepLang(){
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
      },
    }
  }



// WEBPACK FOOTER //
// ./src/components/order/OrderMb.vue